'use strict';

module.exports = {
    eventTypes: require('./eventTypes'),
    eventCategories: require('./eventCategories'),
    eventFilterOperations: require('./eventFilterOperations'),
    eventNotificationMethods: require('./eventNotificationMethods'),
    resourceTypes: require('./resourceTypes'),
    sharedWithGui: require('./sharedWithGui'),
    notificationReqEventTypes: require('./notificationReqEventTypes')
};